import React from 'react';
import type { ReactNode } from 'react';

interface ShowProps {
  readonly when: boolean;
  readonly children: ReactNode;
}

export function Show({ when, children }: ShowProps): JSX.Element {
  return when ? <>{children}</> : <></>;
}
